import { styled } from "@mui/material";
import { Box } from "@mui/material";

const StyledRatingBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 2),
  marginBottom: theme.spacing(1),
}));

export default StyledRatingBox;
